import React from "react";
import {PolicyModal} from "./PolicyModal";
import {termsAndConditionsHtml} from "../../components/shared/policyDocuments";

export function TermsModal({isOpen, onClose}) {
    return (
            <PolicyModal
            isOpen={isOpen}
            onClose={onClose}
            title={"Terms & Conditions"}
            contentHtml={termsAndConditionsHtml}
        />
    );
}
